<template>
  <v-row dense>
    <!-- Broj računa field is hidden - no longer needed -->
    <v-col class="pb-4" cols="4">
      <v-select
        outlined
        dense
        :value="location"
        @input="$emit('update:location', $event)"
        :items="locations"
        label="Prodajno mjesto"
        item-text="name"
        item-value="id"
        return-object
        :disabled="locationDisabled"
        @change="$emit('select-location')"
        hide-details
      ></v-select>
    </v-col>
    <v-col class="pb-4" cols="4">
      <v-select
        outlined
        dense
        :value="cashRegister"
        @input="$emit('update:cashRegister', $event)"
        :items="cashRegisters"
        label="Blagajna"
        item-text="text"
        item-value="id"
        return-object
        @change="$emit('select-register')"
        hide-details
      >
      </v-select>
    </v-col>
    <v-col cols="4">
      <v-select
        outlined
        dense
        :value="paymentType"
        @input="$emit('update:paymentType', $event)"
        :items="paymentTypes"
        label="Način plaćanja"
        item-text="name"
        item-value="value"
        required
        return-object
        @change="$emit('select-payment-type')"
        hide-details
      ></v-select>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: 'ReceiptFormHeader',
  props: {
    receiptNumber: {
      type: String,
      required: true
    },
    location: {
      type: Object,
      default: null
    },
    locations: {
      type: Array,
      required: true
    },
    locationDisabled: {
      type: Boolean,
      default: false
    },
    cashRegister: {
      type: Object,
      default: null
    },
    cashRegisters: {
      type: Array,
      required: true
    },
    paymentType: {
      type: Object,
      required: true
    },
    paymentTypes: {
      type: Array,
      required: true
    }
  }
}
</script>

<style scoped>
.attention >>> .v-text-field__slot input {
  color: red;
}

.normal >>> .v-text-field__slot input {
  color: black;
}
</style>
